"use client"

import { useState } from "react"
import PropTypes from "prop-types"
import { getSettings, setSettings } from "../../utils"
import Words from "../components/words"
import Numbers from "../components/numbers"
import Progress from "../components/progress"
import { useLanguage } from "../../../../../contexts/LanguageContext"

const difficulties = [
  [
    { name: "difficulties/0-4", key: "0-4" },
    { name: "difficulties/0-5", key: "0-5" },
    { name: "difficulties/0-6", key: "0-6" },
    { name: "difficulties/0-7", key: "0-7" },
    { name: "difficulties/0-8", key: "0-8" },
    { name: "difficulties/0-9", key: "0-9" },
  ],
  [
    { name: "difficulties/4", key: "4" },
    { name: "difficulties/3", key: "3" },
    { name: "difficulties/2", key: "2" },
    { name: "difficulties/1", key: "1" },
  ],
  [
    { name: "difficulties/9", key: "9" },
    { name: "difficulties/8", key: "8" },
    { name: "difficulties/7", key: "7" },
    { name: "difficulties/6", key: "6" },
    { name: "difficulties/5", key: "5" },
    { name: "difficulties/4", key: "4" },
    { name: "difficulties/3", key: "3" },
    { name: "difficulties/2", key: "2" },
    { name: "difficulties/1", key: "1" },
  ],
  [
    { name: "difficulties/6", key: "6" },
    { name: "difficulties/7", key: "7" },
    { name: "difficulties/8", key: "8" },
    { name: "difficulties/9", key: "9" },
  ],
  [
    { name: "difficulties/50Plus", key: "50Plus" },
    { name: "difficulties/50Minus", key: "50Minus" },
    { name: "difficulties/100Plus", key: "100Plus" },
    { name: "difficulties/100Minus", key: "100Minus" },
  ],
  [],
]

const TrainingSettings = ({ onStart }) => {
  const { t } = useLanguage()
  const [settings, setSettingsState] = useState(getSettings("trainer"))

  const changeSettings = (name, value) => {
    const newSettings = { ...setSettings(name, value).trainer }
    setSettingsState(newSettings)
  }

  const getThemeNames = () => [
    { name: t("simple") },
    { name: t("brother") },
    { name: t("friend") },
    { name: t("friendBrother") },
    { name: t("transitions") },
    { name: t("allThemes") },
  ]

  return (
    <div className="settings">
      <h2>{t("selectTrainerSettings")}</h2>
      <section>
        <Words
          words={getThemeNames()}
          currentVal={settings.theme}
          description={t("theme")}
          onChange={(val) => {
            changeSettings(`trainer.theme`, val)
          }}
        />
        {settings.theme < 5 && (
          <Words
            words={difficulties[settings.theme].map((d) => ({ name: t(d.name) }))}
            currentVal={settings.difficulties[settings.theme]}
            description={t("difficulty")}
            onChange={(val) => {
              changeSettings(`trainer.difficulties[${settings.theme}]`, val)
            }}
          />
        )}
        {settings.theme !== 4 && (
          <div>
            <Numbers
              minimum={1}
              maximum={4}
              currentVal={settings.count}
              description={t("digits")}
              onChange={(val) => {
                changeSettings("trainer.count", val)
              }}
            />
          </div>
        )}
        <Progress
          minimum={2}
          maximum={43}
          step={1}
          currentVal={settings.steps}
          description={`${t("actionsCount")} = ${settings.steps}`}
          onChange={(val) => {
            changeSettings("trainer.steps", val)
          }}
        />
        <Progress
          minimum={3}
          maximum={20}
          step={1}
          currentVal={settings.time}
          description={`${t("inputTime")} ${settings.time} ${t("sec")}`}
          onChange={(val) => {
            changeSettings("trainer.time", val)
          }}
        />
        <Progress
          minimum={0.3}
          maximum={5}
          step={0.1}
          currentVal={settings.speed}
          description={`${t("speed")} ${settings.speed} ${t("sec")}.`}
          onChange={(val) => {
            changeSettings("trainer.speed", val)
          }}
        />
      </section>
      <footer>
        <button onClick={() => onStart()}>
          <svg fill="#FFF" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path strokeWidth={2} 
              d="M 4.1565441,2.8916291 20.245369,12.180516 4.1084691,21.136604 Z"
            />
          </svg>
          <div>{t("start")}</div>
        </button>
      </footer>
    </div>
  )
}

TrainingSettings.propTypes = {
  onStart: PropTypes.func.isRequired,
}

export default TrainingSettings
